import classNames from 'classnames'
import LoadingDots from 'components/loading-dots/LoadingDots'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Store } from 'store/types'
import { PriceProps as Props } from './types'
import styles from './Price.module.scss'

const Price: FC<Props> = ({ showInjectionPrice }) => {
  // REDUX STORE
  const simulation = useSelector((state: Store) => state.simulation)
  const { price } = simulation

  // i18n
  const { t } = useTranslation('producer')

  return (
    <>
      {simulation.didSimulation && !simulation.isLoading && (
        <div className={classNames('is-flex-row', 'is-flex-end', styles.price)}>
          <div className={classNames(styles.bubble, { [styles['with-promo-code']]: simulation.didSimulation && simulation.promoCode })}>
            {simulation.didSimulation && !simulation.isLoading && (
              <span className={classNames('font-size-s', 'font-weight-regular', 'margin-top-none', 'margin-bottom-none', styles.text)}>
                {simulation.didSimulation && simulation.inputs.promoCode && (
                  <>
                    <span className={classNames(styles.number, styles['is-without-promo-code'])}>
                      <small>&euro;</small>
                      {simulation.inputs.priceWithoutPromo}
                    </span>
                    <br />
                  </>
                )}

                {showInjectionPrice && price.total.injection && (
                  <>
                    <span className={classNames(styles.number, styles['is-without-promo-code'])}>
                      <small>&euro;</small>
                      {Number(
                        Number(simulation.inputs.hasVat ? price.total.totalWithoutVAT : price.total.total) + Number(price.total.injection)
                      ).toFixed(2)}
                    </span>
                    <br />
                  </>
                )}

                <span className={styles.number}>
                  <small>&euro;</small>
                  {simulation.inputs.hasVat ? simulation.price?.total.totalWithoutVAT : simulation.price?.total.total}
                </span>
                <br />

                <span className={styles['per-month']}>/ {t('month', 'maand')}</span>
              </span>
            )}
          </div>
        </div>
      )}

      {simulation.isLoading && <LoadingDots />}
    </>
  )
}

Price.defaultProps = {
  showInjectionPrice: false
}

export default Price
